import React from 'react';
import { PayrollSectionData } from '../../data/sections/PayrollSectionData';

const Payroll = ({ country }) => {
  const fetchPayroll = country
    ? PayrollSectionData.countries.find(
        (c) =>
          c.country.replace(/\s+/g, '-').toLowerCase() ===
          country.replace(/\s+/g, '-').toLowerCase()
      )
    : null;

  if (!fetchPayroll) {
    return <p>Country not found or data not available.</p>;
  }

  
  return (
    <div className="payroll-section-container">
      <h3 >Payroll</h3>
      {fetchPayroll.details && (
        <div className="payroll-section-detail">
          <p className="new-law">
            <strong>Payroll Cycle:</strong> {fetchPayroll.details.payroll_cycle.description}
          </p>
          <p className="new-wage">
            <strong>13'th Salary:</strong> {fetchPayroll.details.th_salary.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default Payroll;
